/**
 * FriendsTabContent
 * Friends tab body for GroupInvitationModal: FriendSelectorList with excludeIds from group members.
 */

import { useState, useCallback, useMemo } from 'react'
import { View } from 'react-native'
import { FriendSelectorList } from '../../friends/FriendSelectorList'
import { getGroupInvitationModalStyles } from './GroupInvitationModal.styles'
import type { Group } from '../../../src/friends/types/groups.types'

export interface FriendsTabContentProps {
  group: Group
  selectedIds: Set<string>
  onToggle: (id: string) => void
  styles: ReturnType<typeof getGroupInvitationModalStyles>
}

export function FriendsTabContent({
  group,
  selectedIds,
  onToggle,
  styles,
}: FriendsTabContentProps) {
  const [bodyWidth, setBodyWidth] = useState(0)
  const excludeIds = useMemo(() => {
    const memberSet = new Set(group.memberIds ?? [])
    const pendingIds = (group.pendingInvitees ?? []).map((p) => p.id).filter(Boolean)
    pendingIds.forEach((id) => memberSet.add(id))
    return [...memberSet]
  }, [group.memberIds, group.pendingInvitees])
  const onBodyLayout = useCallback((e: { nativeEvent: { layout: { width: number } } }) => {
    const w = e.nativeEvent.layout.width
    if (w > 0) setBodyWidth(w)
  }, [])

  return (
    <View style={styles.body} onLayout={onBodyLayout}>
      <FriendSelectorList
        selectedIds={selectedIds}
        onToggle={onToggle}
        excludeIds={excludeIds}
        multiSelect={true}
        layout="grid"
        gridNumColumns={3}
        hideWinRate={true}
        compactText={true}
        contentWidth={bodyWidth > 0 ? bodyWidth : undefined}
        testID="group-invitation-friends-list"
      />
    </View>
  )
}
